import React, { useState } from "react";
import "./style.css";
import AddUserModal from "./component/AddUserModal";
import EditUserModal from "./component/EditUserModal";
import { useUsersContext } from "../../../../context/usersContext";
import { useUserInfo } from "../../../../context/user";
import Icons from "../../../../components/icons";
import DeleteUserModal from "./component/DeleteUserModal";

function TeamContent({ setActiveTab, setPricingHeading }) {
  const user = useUserInfo()[0];
  const userActiveLocation = useUserInfo()[4];
  const { products } = useUsersContext();
  const activeplans = products?.filter((item) => item.activePlan)?.[0];

  const { locationUsers, getLocationUsers } = useUsersContext();
  const [addAddUerModalOpen, setAddUserModalOpen] = useState(false);
  const [editUserModalOpen, setEditUserModalOpen] = useState(false);
  const [editData, setEditData] = useState();
  const [seletedFile, setSeletedFile] = useState();
  const [formData, setFormData] = useState({
    username: "",
    lastName: "",
    email: "",
    contactNumber: "",
  });

  const justCloseIt = () => {
    setAddUserModalOpen(false);
    setEditUserModalOpen(false);
  };

  const handleAddUserModal = (e) => {
    e.preventDefault();
    setAddUserModalOpen(true);
  };

  const handleEditUserModal = (data) => {
    setEditData(data);
    setEditUserModalOpen(true);
  };

  const confirmDelete = (fileInfo) => {
    setSeletedFile(fileInfo);
  };

  const handleDeleteMember = () => {};

  return (
    <div className="">
      <div className="tableHeader items-center">
        <h2
          style={{ marginBottom: "20px", fontSize: "20px", fontWeight: "bold" }}
        >
          Team Members
        </h2>
        <button
          className="bg-black text-white rounded py-3 px-[22px]"
          onClick={(e) => handleAddUserModal(e)}
        >
          Add Team Member
        </button>
      </div>
      <table className="usersTable1 mt-10">
        <tr>
          <th style={{ textAlign: "left" }}>Name</th>
          <th style={{ textAlign: "left" }}>Email</th>
          <th style={{ textAlign: "left" }}>Role</th>
          <th style={{ textAlign: "center" }}>Actions</th>
        </tr>
        {locationUsers?.map((item, index) => (
          <tr>
            <td style={{ textTransform: "capitalize" }}>{item?.userName}</td>
            <td>{item?.email}</td>
            <td style={{ textTransform: "capitalize" }}>{item?.role}</td>
            <td style={{ display: "flex", justifyContent: "center" }}>
              <span
                onClick={() => handleEditUserModal(item)}
                style={{ padding: "5px 10px", cursor: "pointer" }}
              >
                <Icons id="edit" />
              </span>

              <span
                onClick={() => confirmDelete(item)}
                style={{ padding: "5px 10px", cursor: "pointer" }}
              >
                <Icons id="delete" />
              </span>
            </td>
          </tr>
        ))}
      </table>
      <AddUserModal
        isModalOpen={addAddUerModalOpen}
        justCloseIt={justCloseIt}
        getLocationUsers={getLocationUsers}
        user={user}
        userActiveLocation={userActiveLocation}
        activeplans={activeplans}
        locationUsers={locationUsers}
        setActiveTab={setActiveTab}
        setPricingHeading={setPricingHeading}
      />

      <EditUserModal
        isModalOpen={editUserModalOpen}
        justCloseIt={justCloseIt}
        getLocationUsers={getLocationUsers}
        userActiveLocation={userActiveLocation}
        locationUsers={locationUsers}
        activeplans={activeplans}
        editData={editData}
      />

      {seletedFile !== "" ? (
        <DeleteUserModal
          isModalOpen={seletedFile ? true : false}
          yesDelete={handleDeleteMember}
          justCloseIt={() => {
            setSeletedFile(false);
          }}
          fileInfo={seletedFile}
          getLocationUsers={getLocationUsers}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default TeamContent;
